module.exports = __webpack_public_path__ + "static/logo.57c8048c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.jpg
// module id = 432
// module chunks = 35783957827783